import React from 'react';
import { X } from 'lucide-react';
import StatsPlot from './StatsPlot.jsx';

const PlotOverlay = ({ isVisible, onClose, plotProps }) => {
  if (!isVisible) return null;

  return (
    // Main container with fixed position and high z-index
    <div className="lg:hidden relative inset-0 flex items-center justify-center z-50 max-w-xs">
      {/* Clickable backdrop to close the overlay */}
      <div className="absolute inset-0" onClick={onClose}></div>
      
      {/* Plot container */}
      <div className="relative bg-white/90 dark:bg-gray-800/90 rounded-lg shadow-2xl w-full p-4 md:p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">Slide Statistics</h3>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700">
            <X size={20} />
          </button>
        </div>
        <StatsPlot {...plotProps} />
      </div>
    </div>
  );
};

export default PlotOverlay;